import { Component } from '@angular/core';

import { ButtonColor } from '@shared/ui/button/button.component';

@Component({
  selector: 'app-navigation-secondary-hire-freelancers',
  template: `
    <app-bar flTrackingSection="SubnavHireFreelancers">
      <app-bar-item link="/post-project"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </app-bar-item>
      <app-bar-item link="/contest/create.php"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="StartAContest"
      >
        Start a Contest
      </app-bar-item>
      <app-bar-item link="/local"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostALocalJob"
      >
        Post a Local Job
      </app-bar-item>
      <app-bar-item link="/showcase"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Showcase"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        link="/freelancers"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="BrowseDirectory"
      >
        Browse Directory
      </app-bar-item>
      <app-bar-item link="/recruiter"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="GetARecruiter"
      >
        Get a Recruiter
      </app-bar-item>
      <app-bar-item link="/community"
        [exactLink]="true"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Community"
      >
        Community
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation hire bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryHireFreelancersComponent {
  ButtonColor = ButtonColor;
}



// WEBPACK FOOTER //
// ./src/app/navigation-secondary/navigation-secondary-hire-freelancers.component.ts